<search-bar [withSearch]="false"></search-bar>

<section class="content-portfolio" className="pb-20 pt-2">
    <div className="container mx-auto px-4 ">
        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">
                Our Commitment to Your Privacy
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    We only collect personal information that you choose to give us,
                    and we process it with your consent.
                </li>
                <li>
                    By providing us with your details, you are agreeing to our
                    privacy policy.
                </li>
                <li>
                    We require certain personal information to deliver our services.
                    Without it, we may not be able to serve you.
                </li>
                <li>
                    Rest assured, we do not share your personal details with third
                    parties without your explicit permission.
                </li>
            </ul>
        </div>

        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="data_collection_reasons">
                Why We Collect Your Data
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        Data collection aims to improve and personalize your
                        experience, complete transactions, and communicate updates.
                    </span>
                </li>
                <li>
                    <span>
                        Your information will allow us to give you access to specific
                        parts of the platform relevant to you and enable us to provide
                        the services you need.
                    </span>
                </li>
                <li>
                    <span>
                        We will use your information for the purpose of fulfilling
                        service requests you have made, contacting you for your
                        opinions about the site and our services, or notifying you of
                        changes and developments on the site and the services we
                        offer.
                    </span>
                </li>
            </ul>
        </div>

        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="data_use_and_share">
                How We Use and Share Your Data
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        Your data is primarily used to provide and improve services,
                        and we ensure its confidentiality, sharing only when
                        necessary, such as for legal compliance.
                    </span>
                </li>

                <li>
                    <span>
                        Some of the data provided by you will be collected in a
                        profile. This data includes the username and age if you are a
                        client.
                    </span>
                </li>

                <li>
                    <span>
                        Apart from that, the rest of the data is confidential, and we
                        may use or share it if we are obligated to disclose or share
                        your information to comply with any legal obligation, or in
                        order to enforce any commitment to you, or to protect our
                        rights and our affiliated companies. This means we may share
                        information with other companies and organizations for the
                        purposes of fraud protection and prevention. We may also share
                        information and data with third parties that work with or for
                        us or are hosted to provide certain services on the site. The
                        site management commits to providing due care and effort to
                        ensure the confidentiality of the information entrusted to
                        these parties.
                    </span>
                </li>
            </ul>
        </div>

        <!-- <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="subscription_modification">
                Managing Your Subscription and Data
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        If you wish to stop receiving communications from the platform
                        or unsubscribe from our marketing email list, you can request
                        this through our customer service. You also have the right to
                        unsubscribe from third-party websites by communicating with
                        them directly.
                    </span>
                </li>
                <li>
                    <span>
                        If you are a user from within the European Union (GDPR VISITOR
                        RIGHTS), you can access your profile and the data we store.
                        You have the right to correct your personal information or
                        delete it.
                    </span>
                </li>
                <li>
                    <span>
                        Be aware and acknowledge that using the above procedures may
                        prevent you from accessing previously provided paid or free
                        content.
                    </span>
                </li>
            </ul>
        </div> -->

        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="legal_precautions">
                How We Protect Your Data
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        This platform and its staff follow a comprehensive and strict
                        information security policy. The platform's management is
                        committed to ensuring the confidentiality of this information.
                    </span>
                </li>
                <li>
                    <span>
                        We have implemented security policies, rules, and technical
                        measures to protect confidential personal data from
                        unauthorized access, misuse, unauthorized destruction, or
                        accidental loss.
                    </span>
                </li>
                <li>
                    <span>
                        You are solely responsible for maintaining the confidentiality
                        of your password and other account details.
                    </span>
                </li>
                <li>
                    <span>
                        If you have concerns about your password or account details or
                        suspect any unauthorized use of your account, you should
                        contact us immediately. We can deactivate or suspend your
                        account at any time.
                    </span>
                </li>
            </ul>
        </div>

        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="cookies">
                Cookies and Tracking Technologies
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        Cookies enhance user experience, and you have options to
                        manage them in your browser settings.
                    </span>
                </li>
                <li>
                    <span>
                        We may send a small file containing some cookies to your
                        computer or mobile device when you visit our website. This
                        will enable us to:
                    </span>
                </li>
                <li>
                    <span>
                        Log in and identify your device or computer, track your
                        behavior on the platform, and identify your areas of interest
                        to personalize and enhance your experience on this site.
                    </span>
                </li>
                <li>
                    <span>
                        Monitor and study your browsing and navigation patterns on the
                        platform, create your demographic profile, and provide the
                        service that best suits your taste.
                    </span>
                </li>
                <li>
                    <span>
                        Analyze content consumption habits and provide, customize,
                        measure, and improve our advertisements and marketing.
                    </span>
                </li>
                <li>
                    <span>
                        Provide appropriate content permitted in each geographic
                        region based on the intellectual property rights licensed to
                        us.
                    </span>
                </li>
                <li>
                    <span>
                        Share some data to provide you with personalized advertising.
                    </span>
                </li>
                <li>
                    <span>
                        If you do not wish to accept cookies, you can adjust your
                        browser to refuse them. However, this may prevent you from
                        using some parts of the platform.
                    </span>
                </li>
            </ul>
        </div>

        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="external_links">
                External Links and Third-Party Conten
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        The platform may contain links to external websites not
                        operated by us. Please be aware that we have no control over
                        the content and practices of these sites and cannot be held
                        responsible for your private and personal information on them.
                    </span>
                </li>
            </ul>
        </div>

        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="policy_change">
                Updates to Our Privacy Policy
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        We reserve the right to change this policy from time to time.
                        Our updated policy will be displayed on the platform, and by
                        continuing to use and access the platform, you agree to adhere
                        to any changes or updates we make. It is your responsibility
                        to check this policy periodically for differences.
                    </span>
                </li>
            </ul>
        </div>

        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="contact">
                Contact Us
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        For queries or clarifications, please contact us at kawtharuna&#64;gmail.com.
                    </span>
                </li>
            </ul>
        </div>

        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="q_and_a">
                Inquiries
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        If you have any inquiries or concerns regarding our privacy
                        policy or the way we handle personal data, please contact us
                        at kawtharuna&#64;gmail.com.
                    </span>
                </li>
            </ul>
        </div>

        <div className="p-8 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4" id="judicial_disputes">
                Judicial Disputes
            </h2>
            <ul className="list-disc space-y-4 pl-5 text-body-color dark:text-body-color-dark">
                <li>
                    <span>
                        This policy is formulated in accordance with and in agreement
                        with the provisions of the law of the Emirate of Dubai in the
                        United Arab Emirates. Its courts will be the reference in any
                        legal disputes.
                    </span>
                </li>
            </ul>
        </div>

        <!-- {".  "} -->
    </div>
</section>